"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_easy_sort_1 = require("react-easy-sort");
function SoundAdminOption(_a) {
    var label = _a.label, active = _a.active, onClick = _a.onClick, onEdit = _a.onEdit, onDelete = _a.onDelete, onDownload = _a.onDownload;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "sound-admin-option".concat(active ? ' active' : ''), children: [(0, jsx_runtime_1.jsx)(react_easy_sort_1.SortableKnob, { children: (0, jsx_runtime_1.jsx)("div", { className: "handle" }) }), (0, jsx_runtime_1.jsx)("span", { title: label, onClick: function (e) {
                    e.preventDefault();
                    onClick === null || onClick === void 0 ? void 0 : onClick();
                }, children: label }), (0, jsx_runtime_1.jsx)("a", { href: "#", title: 'Delete', onClick: function (e) {
                    e.preventDefault();
                    if (confirm("Are you sure you want to delete '".concat(label, "'?"))) {
                        onDelete === null || onDelete === void 0 ? void 0 : onDelete();
                    }
                }, children: "\u274C" }), (0, jsx_runtime_1.jsx)("a", { href: "#", title: 'Rename', onClick: function (e) {
                    e.preventDefault();
                    onEdit === null || onEdit === void 0 ? void 0 : onEdit();
                }, children: "\u270F\uFE0F" }), onDownload &&
                (0, jsx_runtime_1.jsx)("a", { href: "#", title: 'Download', onClick: function (e) {
                        e.preventDefault();
                        onDownload === null || onDownload === void 0 ? void 0 : onDownload();
                    }, children: "\uD83D\uDCBE" })] }));
}
exports.default = SoundAdminOption;
